import { BigNumber } from 'bignumber.js';

import { Country, Currency, LoginMethod, PhoneUpdateStatus } from './enum';

export const removeAllWhiteSpacesAndDashes = (value: string) => value.replace(/[- ]/g, '');

export const convertCurrency = (amount: number, from: Currency, to: Currency) => {
  switch (from) {
    case to:
      return amount;
    case Currency.AED:
    case Currency.QAR:
    case Currency.SAR: {
      switch (to) {
        case Currency.AED:
        case Currency.QAR:
        case Currency.SAR: {
          return amount;
        }
        case Currency.BHD:
        case Currency.OMR:
        case Currency.KWD: {
          return amount / 10;
        }
        case Currency.GBP: {
          return amount / 5;
        }
        default: {
          return amount;
        }
      }

      break;
    }
    case Currency.BHD:
    case Currency.OMR:
    case Currency.KWD: {
      switch (to) {
        case Currency.BHD:
        case Currency.OMR:
        case Currency.KWD: {
          return amount;
        }
        case Currency.AED:
        case Currency.SAR:
        case Currency.QAR: {
          return amount * 10;
        }
        case Currency.GBP: {
          return amount * 2;
        }
        default: {
          return amount;
        }
      }
      break;
    }
    case Currency.GBP: {
      switch (to) {
        case Currency.AED:
        case Currency.SAR:
        case Currency.QAR: {
          return amount * 5;
        }
        case Currency.BHD:
        case Currency.OMR:
        case Currency.KWD: {
          return amount / 2;
        }
        default: {
          return amount;
        }
      }
      break;
    }
    default:
      return 0;
  }

  return 0;
};

export const roundAmount = (amount: number, currency: Currency): number => {
  const fixedDecmials = getAmountDecimalFromCurrency(currency);

  const bigNumber = new BigNumber(amount);
  return +bigNumber.toFixed(fixedDecmials);
};

export const getAmountDecimalFromCurrency = (currency: Currency) => {
  switch (currency) {
    case Currency.BHD:
    case Currency.KWD:
    case Currency.OMR:
    case Currency.GBP:
      return 3;
    case Currency.SAR:
    case Currency.AED:
    case Currency.QAR:
      return 2;
    default:
      return 3;
  }
};

export const getRandomIntercomId = () => {
  const affiliateAnonymousId = `affiliate-guest-${Math.random().toString(36).slice(2, 15)}`

  return affiliateAnonymousId
}

export const setLoginMethod = (method: LoginMethod) => {
  localStorage.setItem('loginMethod', method);
};

export const getLoginMethod = (): LoginMethod | null => localStorage.getItem('loginMethod') as LoginMethod | null;

export const clearLoginMethod = () => {
  localStorage.removeItem('loginMethod');
};

export const setPhoneUpdateStatus = (status: PhoneUpdateStatus) => {
  localStorage.setItem('phoneUpdateStatus', status);
};

export const getPhoneUpdateStatus = (): PhoneUpdateStatus | null => localStorage.getItem('phoneUpdateStatus') as PhoneUpdateStatus | null;

export const clearPhoneUpdateStatus = () => {
  localStorage.removeItem('phoneUpdateStatus');
};

export const getCurrencyFromCountry = (countryCode: string): Currency => {
  const countryToCurrencyMap: Record<string, Currency> = {
    [Country.AE]: Currency.AED,
    [Country.BH]: Currency.BHD,
    [Country.SA]: Currency.SAR,
    [Country.QA]: Currency.QAR,
    [Country.OM]: Currency.OMR,
    [Country.KW]: Currency.KWD,
    [Country.GB]: Currency.GBP
  };
  
  return countryToCurrencyMap[countryCode.toUpperCase()] || Currency.SAR;
};
